export const DASHBOARD_FILTERS_CHANGED_EVENT = 'dashboard:filters-changed';
export const DASHBOARD_SECTION_STATE_CHANGED_EVENT = 'dashboard:section-state-changed';
